export default __webpack_public_path__ + "static/media/iphone_en_pwa.03cf371a.png";